import { styled } from '@material-ui/core/styles';
import { Avatar as _Avatar, Typography } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import React from 'react';
import { SPACING_UNIT } from '../constant/spacing';
var AvatarWithName = function (_a) {
    var imageUrl = _a.imageUrl, name = _a.name, small = _a.small, className = _a.className;
    var avatar;
    if (!imageUrl) {
        avatar = small ? React.createElement(SmallIcon, { color: "primary" }) : React.createElement(Icon, { color: "primary" });
    }
    else {
        avatar = small ? React.createElement(SmallAvatar, { alt: name, src: imageUrl }) : React.createElement(Avatar, { alt: name, src: imageUrl });
    }
    return (React.createElement(Root, { className: className },
        avatar,
        React.createElement(Name, { variant: "body2" }, name)));
};
export var Root = styled('div')({
    display: 'flex',
    alignItems: 'center',
});
var Avatar = styled(_Avatar)({
    width: 32,
    height: 32,
});
var SmallAvatar = styled(_Avatar)({
    width: 20,
    height: 20,
});
var Icon = styled(AccountCircle)({
    width: 32,
    height: 32,
    color: 'white',
});
var SmallIcon = styled(AccountCircle)({
    width: 20,
    height: 20,
    color: 'white',
});
var Name = styled(Typography)({
    marginLeft: SPACING_UNIT,
    maxWidth: 300,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'white',
});
export default AvatarWithName;
